<template>
  <div
    :key="$store.getters['resource/currentResource'].key"
    class="white-container">
    <TemplateView
      :fields="fields"
      :editing="true"
    />
  </div>
</template>

<script>
  import fields from './templateCreationFields.js';
  import TemplateView from './TemplateView';

  export default {
    name: 'TemplateEditing',
    middleware: 'auth',
    components: {
      TemplateView
    },
    computed: {
      id () {
        return this.$route.params.id || ''
      }
    },
    data () {
      return {
        fields: fields
      }
    },
    mounted () {
      if(!this.id){
        this.$router.push({path: '/emails'})
      }
    }
  }
</script>